import type { ReactNode } from "react";

/**
 * Props for {@link SupportTicketDetailField}.
 */
interface SupportTicketDetailFieldProps {
  label: string;
  value: ReactNode;
}

/**
 * Label and value pair used in the ticket metadata panel.
 *
 * @param props - Field label and rendered value.
 * @returns Vertical detail field cell.
 */
const SupportTicketDetailField = ({
  label,
  value,
}: SupportTicketDetailFieldProps) => {
  return (
    <div className="support-tickets-detail-field flex min-w-0 flex-col gap-1">
      <span className="text-tiny font-normal leading-[1.125rem] tracking-[0.0125rem] text-primaryGray-7">
        {label}
      </span>
      <div className="text-tiny font-semibold leading-[1.125rem] tracking-[0.0125rem] text-[#0F0F0F]">
        {value}
      </div>
    </div>
  );
};

export default SupportTicketDetailField;
